import React from "react";
import { IsAuthenticated } from "@/utils/auth";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const donorProfileSchema = z.object({
  page: z.string(),
});

export const Route = createFileRoute("/$lang/donor-profile")({
  component: React.lazy(() =>
    import("@/pages/donor-profile").then((mod) => ({
      default: mod.MyDonations,
    })),
  ),
  validateSearch: (search) => donorProfileSchema.parse(search),
  beforeLoad: async () => await IsAuthenticated(),
});
